import { TYPES } from "./draft_dialog.type";

const initState = {
  draftDialogEdited: [],
};

const draftDialogReducer = (state = initState, action) => {
  const { type, payload } = action;
  switch (type) {
    case TYPES.SET_DRAFT_DIALOG_EDITED:
      return {
        ...state,
        draftDialogEdited: payload,
      };

    default:
      return state;
  }
};

export default draftDialogReducer;
